//Imports node_modules
import PulseLoader from "react-spinners/PulseLoader"
import PuffLoader from "react-spinners/PuffLoader"

import React, { useContext, useState } from "react"
import { useEffect } from "react";

var override = {
    display: "block",
    margin: "0 auto",
    borderColor: "red",
};

//Este Botão foi principlamente feito para evitar duplo click, detetar micro deslizes de dedos, touch and click events
const LoadingLayout = (params) => {

    //Variaveis
    let [loading, setLoading] = useState(true);
    let [color, setColor] = useState("#576FE3");

    useEffect(() => {
        setColor("#576FE3");
    }, []);

    return (
        <PuffLoader
            color={color} loading={loading} cssOverride={override} size={params.size ? params.size : 150}>
        </PuffLoader>
    )
}

export default LoadingLayout